const mutations = {

  setInitialPageLoad: (state, val) => {
    state.flags.initialPageLoad = val;
  },
  setShowDebugIds: (state, val) => {
    state.flags.showDebugIds = val;
  },
  setShowMode: (state, val) => {
    state.flags.showMode = val;
  },
  setLoadingInitialApiData: (state, val) => {
    state.flags.loadingInitialApiData = val;
  },
  setLku: (state, lku) => {
    state.lku = lku;
  },
  setSPGSLink: (state, ds) => {
    state.spgsLink = ds;
  },
  setLPGSLink: (state, ds) => {
    state.lpgsLink = ds;
  },
  setFootnotes: (state, fn) => {
    state.footnotes = fn;
  },
  addApiError: (state, err) => {
    state.apiErrors.push(err);
  },
  addDataError: (state, err) => {
    state.dataErrors.push(err); // err: string
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js